import { useState, useEffect } from "react";
import { Phone, MessageCircle, ArrowUp } from "lucide-react";
import { OWNER } from "@/data/portfolio";

export default function FloatingButtons() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const whatsappUrl = `https://wa.me/${OWNER.whatsapp}?text=${encodeURIComponent("Hi Sunil, I'd like to enquire about a website.")}`;

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="w-11 h-11 rounded-full grid place-items-center bg-white/8 backdrop-blur-md border border-white/15 text-white hover:bg-[#FF3B30] hover:border-[#FF3B30] transition-all"
          aria-label="Scroll to top"
          data-testid="scroll-top-btn"
        >
          <ArrowUp size={16} />
        </button>
      )}

      <a
        href={`tel:${OWNER.phone}`}
        className="group relative w-14 h-14 rounded-full grid place-items-center bg-black/70 backdrop-blur-md border border-white/15 text-white hover:bg-[#FF3B30] hover:border-[#FF3B30] transition-all shadow-lg"
        aria-label="Call Sunil"
        data-testid="floating-call-btn"
      >
        <Phone size={20} />
        <span className="absolute right-full mr-3 px-3 py-1.5 rounded-full bg-black/80 border border-white/10 text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Dial Enquiry
        </span>
      </a>

      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative w-14 h-14 rounded-full grid place-items-center bg-[#25D366] text-white shadow-lg shadow-emerald-500/40 hover:scale-110 transition-transform"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp-btn"
      >
        <MessageCircle size={22} />
        <span className="absolute inset-0 rounded-full border-2 border-[#25D366] animate-pulse-ring" />
        <span className="absolute right-full mr-3 px-3 py-1.5 rounded-full bg-black/80 border border-white/10 text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Chat on WhatsApp
        </span>
      </a>
    </div>
  );
}
